// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1o-Rd","errorLogs":"styles_errorLogs__28p2Q"};